import { render, staticRenderFns } from "./WelcomeTasks.vue?vue&type=template&id=48f09dff&scoped=true&"
import script from "./WelcomeTasks.vue?vue&type=script&lang=js&"
export * from "./WelcomeTasks.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeTasks.vue?vue&type=style&index=0&id=48f09dff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f09dff",
  null
  
)

export default component.exports